﻿import React, { useState, useEffect } from 'react';
import { UserDataStore } from '../store/userDataStore';
import { GravimetricBenchSheet } from '../models/gravimetric-bench-sheet';
import { BenchSheetTechnologyType, NoteType, DocumentType, Entities } from '../models/enums';
import SecondaryBenchSheetInstrument from './SecondaryBenchSheetInstrument';
import BenchSheetHeaderComponent from './BenchSheetHeaderComponent';
import BenchSheetData from './BenchSheetData';
import NoteViewer from './NoteViewer';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import { ItemBasicInformation } from '../models/item-basic-information';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import TicketLogEntryForm from './TicketLogEntryForm';
import BenchSheetToolbar from './BenchSheetToolbar';
import { DocumentationConstants } from '../store/documentation-constants';
import DmaFooter from './DmaFooter';

import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 1;

export default function GravimetricBenchSheetForm() {
    const [canEdit, setCanEdit] =
        useState<boolean>(false);

    const [benchSheet, setBenchSheet] =
        useState<GravimetricBenchSheet>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        setAuthorizations();
        getAllData();
    }, []);

    const parts = window.location.href.split('/');
    const benchSheetId = parts[parts.length - 1];

    key++;

    return (
        <div className="pw-content">
            <div>

                <BenchSheetToolbar title="Gravimetric Bench Sheet"
                    subtitle="Gravimetric"
                    auditRowPointer={benchSheetId} entity={Entities.GravimetricBenchSheets}
                    technologyId={BenchSheetTechnologyType.Gravimetric}
                    documentationId={DocumentationConstants.DENSITYBenchSheets}
                    showItemInformation={showBenchSheetInformationDialog}
                    showTicketLog={showTicketLogEntryDialog} />

                <BenchSheetHeaderComponent benchSheetId={benchSheetId} readOnly={!canEdit} />

                <SecondaryBenchSheetInstrument benchSheetId={benchSheetId} isReadOnly={!canEdit}
                    title="Gravimetric Instrument"
                    technology={BenchSheetTechnologyType.Gravimetric} />

                <div className="pw-comp-row-scroll-fixed-grid">
                    <NoteViewer height='10rem' title="Bench Sheet Note"
                        noteType={NoteType.BenchSheet} parentId={benchSheetId} />
                </div>

                <div className="pw-comp-row-scroll-fixed-grid">
                    <BenchSheetData parentId={benchSheetId}
                        readOnly={!canEdit} canDelete={true}
                        technology={BenchSheetTechnologyType.Gravimetric}
                        hideImageHandler={true}
                        documentType={DocumentType.General} />
                </div>

            </div>

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="HPLC Bench Sheet" contextData={benchSheet}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function setAuthorizations() {
        const user = UserDataStore.getCurrentUser();

        const canEditRoles = ["SA", "MF-A", "MF-L", "MF-T", "PP-A", "PP-L", "PP-T", "DIST-A", "BA-A", "QCP-A", "QCD-A", "RD-A", "RD-L", "RD-T"];
        const canEdit = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));

        setCanEdit(canEdit);
    }

    //GET methods

    async function getBenchSheet() {
        await CrudFunctions.getData(`benchsheets/benchsheet/${benchSheetId}`)
            .then(data => {
                setBenchSheet(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet Data");
            });
    }

    // other functions

    async function getAllData() {
        getBenchSheet();
    }

    // show/hide

    function showTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(true);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function showBenchSheetInformationDialog() {
        if (benchSheet) {
            let itemBasicInitInformation: ItemBasicInformation = {
                rowPointer: benchSheet.benchSheetId,
                createTimestamp: benchSheet.createTimestamp,
                lastModifiedTimestamp: benchSheet.modifyTimestamp,
                createUser: benchSheet.createUser,
                modifyUser: benchSheet.modifyUser
            };

            setItemBasicInitInformation(itemBasicInitInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}


